import CallCodeInput from "./create-shipment-form/call-code-input";
import { useState, useEffect } from "react";
import { validateMobileNo } from "@/lib/validation";
import { validateInput } from "./create-shipment-form/form-w-validation";
import { TickSVG } from "./svg";
import classNames from "classnames";
import InputGuideText from "@/components//input-guide-text";
import { WhatsAppLogoSVG } from "@/components/svg";

export default function PhoneNoInput({
  label,
  callCode,
  setCallCode,
  name,
  type,
  state,
  setState,
  isValid,
  setIsValid,
  disabled = false,
  isWhatsApp = false,
  ...props
}) {
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    if (state) {
      const msg = validateMobileNo(state, callCode);
      setIsValid(!msg);
      setErrMsg(msg);
    }
  }, []);
  return (
    <div className="group">
      <label
        className={classNames(
          "block font-normal text-subheading-gray text-sm",
          "group-focus-within:text-dark-purple"
        )}
        htmlFor={name}
      >
        {label}
        {isWhatsApp && (
          <span className="inline-flex ml-1">
            (
            <WhatsAppLogoSVG className="w-5 h-5 mr-0.5" aria-hidden="true" />
            WhatsApp required)
          </span>
        )}
      </label>
      <div
        className={classNames(
          "flex h-10 mt-1 relative rounded-xl",
          "border focus-within:border-light-purple focus-within:shadow-border-focus",
          disabled ? "bg-gray-2" : "",
          isValid
            ? "border-border-dark-gray shadow-border"
            : "border-error-red shadow-border-error"
        )}
      >
        <CallCodeInput
          callCode={callCode}
          setCallCode={setCallCode}
          disabled={disabled}
        />
        <hr className="h-2/3 self-center border-l border-border-gray group-focus-within:border-light-purple" />
        <input
          type="tel"
          id={name}
          className={classNames(
            "block w-full pl-3 pr-10 py-2.5 text-gray-4 disabled:bg-gray-2",
            "text-sm rounded-xl focus:outline-none"
          )}
          disabled={disabled}
          value={state}
          onBlur={(e) => {
            const msg = validateMobileNo(e.target.value, callCode);
            setIsValid(!msg);
            setErrMsg(msg);
            validateInput(type, e.target.value, setState);
          }}
          onChange={(e) => validateInput(type, e.target.value, setState)}
          {...props}
        ></input>
        {isValid !== "none" ? (
          isValid ? (
            <TickSVG
              className={classNames(
                "absolute right-0.5 top-[50%] -translate-y-[50%]",
                "group-focus-within:invisible mr-2 stroke-dark-purple"
              )}
            />
          ) : null
        ) : null}
        <InputGuideText className="absolute top-10" isWarning={true}>
          {errMsg}
        </InputGuideText>
      </div>
    </div>
  );
}
